module.exports = __webpack_public_path__ + "assets/small-logo.5bcf0d27.svg";